/**
 * Header cart count — keep [data-count] badges in sync with /cart.js
 */
(function (doc, win) {
  'use strict';

  var COUNT_SELECTORS = [
    '[data-count]',
    '[data-cart-count]',
    '[data-header-cart-count]',
    '.header--modern__cart-count',
    '.header__cart-count',
    '.cart-count',
    '.item__count'
  ].join(',');

  function updateCount(count) {
    var n = String(count || 0);
    doc.querySelectorAll(COUNT_SELECTORS).forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
      el.setAttribute('data-cart-count', n);
    });
  }

  function sync() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (cart) {
        if (!cart) return;
        updateCount(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  win.NNHCartCount = {
    update: updateCount,
    sync: sync
  };

  doc.addEventListener('cart:refresh', sync);
  doc.addEventListener('cart:item-added', sync);
  doc.addEventListener('booster:cart:update', sync);

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
}(document, window));
